export default __webpack_public_path__ + "45ea6f68e230665cbd31e8c96f6432ab.png";